import { Dispatch, ExtraArgs, GetState } from '../../types'
import { AlertsLimitExceeded } from './model'
import { fetchAllAlerts, isLoading } from './AlertsListPage/actions'
import { changeAPIResponseCodesLimit } from './AlertModals/BasicAlertModal/actions'
import { AlertsMetaResponse } from '../../remote-api/models'

/**
 *  Action Constants
 */
export const ChangeBasicAlertsEnabled = 'Monitoring/Alerts/ChangeBasicAlertsEnabled'
export const ChangeAPIAlertsEnabled = 'Monitoring/Alerts/ChangeAPIAlertsEnabled'
export const ChangeBasicAlertsLimitExceeded = 'Monitoring/Alerts/ChangeBasicAlertsLimitExceeded'

/**
 *  Action Type
 */
export type ChangeBasicAlertsEnabledAction = {
  type: 'Monitoring/Alerts/ChangeBasicAlertsEnabled'
  payload: { isBasicAlertsEnabled: boolean }
}

export type ChangeAPIAlertsEnabledAction = {
  type: 'Monitoring/Alerts/ChangeAPIAlertsEnabled',
  payload: { isAPIBasicAlertsEnabled: boolean }

}

export type ChangeBasicAlertsLimitExceededAction = {
  type: 'Monitoring/Alerts/ChangeBasicAlertsLimitExceeded'
  payload: { isBasicAlertsLimitExceeded: boolean }
}

/**
 *  Action Creators
 */
export const changeBasicAlertsEnabledAction = (isBasicAlertsEnabled: boolean): ChangeBasicAlertsEnabledAction => ({
  type: ChangeBasicAlertsEnabled,
  payload: {isBasicAlertsEnabled}
})

export const changeBasicAlertsEnabled = (isBasicAlertsEnabled: boolean) => (dispatch: Dispatch) => {
  dispatch(changeBasicAlertsEnabledAction(isBasicAlertsEnabled))
}

export const changeAPIAlertsEnabledAction = (isAPIBasicAlertsEnabled: boolean): ChangeAPIAlertsEnabledAction => ({
  type: ChangeAPIAlertsEnabled,
  payload: {isAPIBasicAlertsEnabled}
})

export const changeAPIBasicAlertsEnabled = (isAPIBasicAlertsEnabled: boolean) => (dispatch: Dispatch) => {
  dispatch(changeAPIAlertsEnabledAction(isAPIBasicAlertsEnabled))
}

export const fetchAlertsMeta = () => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
  dispatch(isLoading())
  const profile = getState().monitoring.auth.profile
  const orgId = profile.organizationId

  return api.ui(getState).fetchAlertsMeta(orgId).then( (alertsMeta: AlertsMetaResponse) => {
    const isBasicAlertsEnabled = alertsMeta.basic.enabled
    const isApiAlertsEnabled = alertsMeta.basic.api.enabled || false

    pushMonitoringBasicAlertsEnabledToAppcues(profile.ownerId, isBasicAlertsEnabled)
    dispatch(changeBasicAlertsEnabled(isBasicAlertsEnabled))
    dispatch(fetchAllAlerts(true))
    dispatch(changeBasicAlertsLimitExceeded(alertsMeta.basic.limit.exceeded))
    dispatch(changeAPIBasicAlertsEnabled(isApiAlertsEnabled))
    dispatch(changeAPIResponseCodesLimit(alertsMeta.basic.api.responseCodesLimit))
  }).catch(() => {
    dispatch(changeBasicAlertsEnabled(false))
    dispatch(fetchAllAlerts(true))
    dispatch(changeBasicAlertsLimitExceeded(true))
    dispatch(changeAPIBasicAlertsEnabled(false))
  })
}

export const changeBasicAlertsLimitExceededAction = (isBasicAlertsLimitExceeded: boolean): ChangeBasicAlertsLimitExceededAction => ({
  type: ChangeBasicAlertsLimitExceeded,
  payload: {isBasicAlertsLimitExceeded}
})

export const changeBasicAlertsLimitExceeded = (isBasicAlertsLimitExceeded: boolean) => (dispatch: Dispatch) => {
  dispatch(changeBasicAlertsLimitExceededAction(isBasicAlertsLimitExceeded))
}

export const fetchBasicAlertsLimitExceeded = () => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
  const orgId = getState().monitoring.auth.profile.organizationId

  return api.ui(getState).fetchBasicAlertsLimitExceeded(orgId).then( (alertsLimitExceeded: AlertsLimitExceeded) => {
    const isBasicAlertsLimitExceeded = alertsLimitExceeded.basic
    dispatch(changeBasicAlertsLimitExceeded(isBasicAlertsLimitExceeded))
  }).catch(() => {
    dispatch(changeBasicAlertsLimitExceeded(true))
  })
}

const pushMonitoringBasicAlertsEnabledToAppcues = (ownerId: string, isBasicAlertsEnabled: boolean) => {
  if (window.analytics) {
    window.analytics.identify(ownerId, {monitoringBasicAlertsEnabled: isBasicAlertsEnabled})
  }
}

export type AlertsActions =
  | ChangeBasicAlertsEnabledAction
  | ChangeBasicAlertsLimitExceededAction
  | ChangeAPIAlertsEnabledAction
